/** @jsxImportSource @emotion/react */

import React from "react";
import {
  AppBar,
  Box,
  Container,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { LinkComp } from "./headerStyle";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";
import { css } from "@emotion/react";
import { Link } from "react-router-dom";

const searchLi = css`
  color: #767676;
  font: normal 500 14px/22px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  margin-bottom: 20px;
  text-decoration: none;
  :last-child {
    margin-bottom: 0;
  }
  :hover {
    color: #fff;
  }
`;

const spanImageStyle = css`
  margin: 0;
  margin-left: 4%;
  display: flex;
  justify-content: flex-start;
  font-size: 16px !important;
  font: normal 500 14px/22px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
`;

export const SubNav = ({
  borderTabValue,
  classes,
  v4,
  handleClose,
  responseData,
  collection,
  setSearchTerm,
  debouncedSearchTerm,
  searchIconClicked,
  setSearchIconClicked,
  fetchMeiliSearchData,
  setCollection,
  navigate,
  searchTerm,
}) => {
  let subNavData;

  useEffect(() => {
    debouncedSearchTerm &&
      debouncedSearchTerm.length > 1 &&
      fetchMeiliSearchData(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const handleClick = (target, url) => {
    if (target === "_blank") window.open(url, "_blank");
  };

  const closeSuggestedFieldOnEnter = (e) => {
    if (e.key === "Enter") {
      navigate("/search", {
        state: { searchedItem: e.target.value },
      });
      setSearchIconClicked(false);
      setSearchTerm("");
      setCollection([]);
    }
  };

  responseData.forEach((data) => {
    if (
      data?.children[0]?.children.length > 0 &&
      borderTabValue === data.dataAttribute &&
      !searchIconClicked
    ) {
      subNavData = data.children.map((product) => {
        return (
          <Box key={v4()} className={classes.productSubNavBox}>
            <Typography css={spanImageStyle} variant="body1">
              {product?.title}
            </Typography>
            <Box sx={{ display: { xs: "flex" } }}>
              {product?.children.map((d) => (
                <Box
                  key={v4()}
                  className={classes.flexClass}
                  onClick={() => handleClick(d?.target, d?.url)}
                >
                  <Box
                    component="img"
                    sx={{
                      width: "70%",
                      maxHeight: "110px",
                      pb: 1,
                      marginTop: "-4%",
                      ml: "-1%",
                      cursor: "pointer",
                    }}
                    src={`${process.env.REACT_APP_BASEURL}${d?.thumbnailImage?.formats?.thumbnail.url}`}
                    onClick={() => {
                      d.target !== "_blank" && navigate(d.url);
                    }}
                  ></Box>
                  <LinkComp
                    to={d.target === "_blank" ? "#" : d.url}
                    sx={{
                      flexDirection: "row",
                      justifyContent: "left",
                      marginLeft: "15%",
                      fontSize: "16px",
                    }}
                  >
                    {d.title}
                  </LinkComp>
                </Box>
              ))}
            </Box>
          </Box>
        );
      });
    } else if (
      data?.children.length > 0 &&
      borderTabValue === data.dataAttribute &&
      !searchIconClicked
    ) {
      subNavData = (
        <Box className={classes.newsSubNavBox}>
          {data.children.map((d, index) => {
            return (
              <LinkComp
                to={d.target === "_blank" ? "#" : d.url}
                key={v4()}
                state={{ id: index }}
                onClick={() => handleClick(d.target, d.url)}
                style={{ "font-size": "16px" }}
              >
                {d.title}
              </LinkComp>
            );
          })}
        </Box>
      );
    } else if (searchIconClicked) {
      subNavData = (
        <Box
          sx={{
            width: "100%",
            display: "flex",
          }}
        >
          <Box
            sx={{
              width: "40%",
              display: "flex",
              position: "relative",
              left: "30%",
            }}
          >
            <TextField
              inputProps={{ className: classes.input }}
              id="global-search"
              //  placeholder="EQS"
              variant="standard"
              fullWidth
              onKeyDown={(e) => closeSuggestedFieldOnEnter(e)}
              onChange={({ target }) => setSearchTerm(target.value)}
            />
            <SearchIcon
              style={{ position: "relative", right: "3%", cursor: "pointer" }}
              onClick={() => {
                navigate("/search", {
                  state: { searchedItem: searchTerm },
                });
                setSearchIconClicked(false);
                setSearchTerm("");
                setCollection([]);
              }}
            />
          </Box>
          {collection && collection.length > 0 && (
            <Box
              sx={{
                position: "absolute",
                top: "57px",
                width: "36%",
                padding: "24px 32px",
                left: "30%",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#2e2e2e",
              }}
            >
              {collection &&
                collection.map((data, index) => {
                  return (
                    <Link
                      to="/search"
                      state={{
                        searchedItem: data.title,
                      }}
                      onClick={() => {
                        setSearchIconClicked(false);
                        setSearchTerm("");
                        setCollection([]);
                      }}
                      key={data + index}
                      css={searchLi}
                    >
                      {data.title}
                    </Link>
                  );
                })}
            </Box>
          )}
        </Box>
      );
    }
  });

  return (
    <AppBar
      position="static"
      sx={{ display: { xs: "none", md: "flex" } }}
      onMouseLeave={handleClose}
    >
      <Container maxWidth="false" sx={{ backgroundColor: "#2e2e2e" }}>
        <Toolbar
          px={1}
          disableGutters
          sx={{ alignItems: "center", justifyContent: "center" }}
        >
          {subNavData}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
